import styled from 'styled-components'

export const CommentItem = styled.div`
display:flex;
justify-content: center;
align-items: center;
border-bottom: 1px solid #d6d6d6;
padding: 22px 0px;
img{
    width: 70px;
    height: 72px;
}
`;
export const CommentInfo = styled.div`
width: 100%;
padding: 0px 14px;
> div{
    display: flex;
    justify-content: space-between;
    div span:nth-child(1){
        font-size: 14px;
        margin-right: 12px;
        font-weight: 600;
        color:#4a4a49;
    }
    div span:nth-child(2){
        font-size: 14px;
        i{
            font-size: 12px;
            color: #ffb400;
            margin: 1px;
        }
}

> span{
    font-size: 12px;
    color: #272626;
    font-weight: 500;
}
}
p{
    font-size: 11px;
    margin-top: 4px;
}
`;
